import Vue from 'vue'
import { 
    Button, 
    Form, 
    Field,
    DropdownMenu,
    DropdownItem,
    CellGroup,
    Dialog,
    Area,
    ActionSheet,
    Picker,
    Popup,
    Tabs,
    Tab,
    PullRefresh,
    Icon,
    Steps,
    Step,
    RadioGroup, 
    Radio,
    Card,
    Notify,
    Pagination     
} from 'vant'

Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(CellGroup)
Vue.use(Dialog)
Vue.use(Area)
Vue.use(ActionSheet)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(PullRefresh)
Vue.use(Icon)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Notify)
Vue.use(Pagination)